<Slide :i :slide>

    <div class="media-outer interactive i-mapmaj">

        <div class="i-mapmaj-video-wrapper" ref:videos>
            {{#each levels as level}}
            <video muted playsinline on:ended="onEnd(event)" class="forward media-video {{ isCurrent(level, current_level, direction, 'forward') }}">
                <source src="{{ video(level.forward.replace('.mp4', '.webm')) }}" type="video/webm">
                <source src="{{ video(level.forward) }}" type="video/mp4">
            </video>

            <video muted playsinline on:ended="onEnd(event)" class="reverse media-video {{ isCurrent(level, current_level, direction, 'reverse') }}">
                <source src="{{ video(level.reverse.replace('.mp4', '.webm')) }}" type="video/webm">
                <source src="{{ video(level.reverse) }}" type="video/mp4">
            </video>
            {{/each}}
        </div>
        <!-- just creating our bullets here -->
        {{#each levels as level}}
        <div class="step"></div>
        {{/each}}

        <div class="interactive__layer">

            <!-- earth labels -->
            {{#if show_label && current_level.name === "earth"}}
            <div class="i-mapmaj__earth" in:fade out:fade="{duration: 200}">
                <div class="i-mapmaj__label1a">
                    <h6 class="i-mapmaj__label1a-text">Majuro</h6>
                </div>
                <div class="i-mapmaj__label--asia">
                    <h6 class="i-mapmaj__label--asia-text">Asia</h6>
                </div>
                <div class="i-mapmaj__label--australia">
                    <h6 class="i-mapmaj__label--australia-text">Australia</h6>
                </div>
                <div class="i-mapmaj__label--hawaii">
                    <h6 class="i-mapmaj__label--hawaii-text">Hawaii</h6>
                </div>
            </div>
            {{/if}}

            <!-- marshall islands labels -->
            {{#if show_label && current_level.name === "rmi"}}
            <div class="i-mapmaj__marshall" in:fade out:fade="{duration: 200}">

                <div class="slide__text slide__text--1 slide__text--interactive step">
                    <p class="slide__text-inner">{{ slide.text_list[0] }}</p>
                </div>

                <div class="i-mapmaj__marshall-border"></div>
                <div class="i-mapmaj__label2a">
                    <h5 class="i-mapmaj__label2a-text">Marshall Islands</h5>
                </div>
                <div class="i-mapmaj__label2b">
                    <h6 class="i-mapmaj__label2b-text">Majuro</h6>
                </div>
            </div>
            {{/if}}

            <!-- majuro labels -->
            {{#if show_label && current_level.name == "majuro"}}
            <div class="i-mapmaj__majuro" in:fade out:fade="{duration: 200}">
                <div class="slide__text slide__text--2 slide__text--interactive step">
                    <p class="slide__text-inner">{{ slide.text_list[1] }}</p>
                </div>
                <div class="i-mapmaj__label3a">
                    <h5 class="i-mapmaj__label3a-text">Majuro</h5>
                </div>
                <div class="i-mapmaj__label3b">
                    <h6 class="i-mapmaj__label3b-text">Izerman's House</h6>
                </div>
            </div>
            {{/if}}

        </div>

        <audio ref:audio>
            <source src="{{ media('audio/vo/Iz_Audio_Map.mp3') }}" type="audio/mp3">
            {{#if slide.vtt}}
            <track ref:track src="{{ slide.vtt }}" label="English captions" kind="metadata" srclang="en" default>
            {{/if}}
        </audio>
    </div>

    <Captions ref:display :cues />

</Slide>

<style>
ref:videos video {
    opacity: 0;
}

ref:videos video.current {
    opacity: 1;
}
</style>

<script>
import Slide from '../Slide.html'
import Captions from '../video/Captions.html'
import * as helpers from '../helpers'
import { fade } from 'svelte-transitions'


export default {

    components: {
        Slide,
        Captions,
    },

    transitions: {
        fade,
    },

    data() {

        const levels = [
            {name: 'earth', label: 'Earth', 
                forward: 'video/mapmaj_earth_intro.mp4', 
                reverse: 'video/mapmaj_marsh_to_earth.mp4'},
            {name: 'rmi', label: 'Marshall Islands', 
                forward: 'video/mapmaj_earth_to_marsh.mp4', 
                reverse: 'video/mapmaj_maj_to_marsh.mp4'},
            {name: 'majuro', label: 'Majuro', 
                forward: 'video/mapmaj_marsh_to_maj.mp4',
                reverse: 'video/mapmaj_marsh_to_maj.mp4'},
        ];

        return {
            levels,
            current_level: levels[0],
            direction: 'forward',
            show_label: false,
            cues: []
        }
    },

    oncreate() {
        // debug
        window.majmap = this;

        this.observers = [];

        this.observers.push(this.store.observe('current_slide', (current, prev) => {

            if (current === this.get('i')) {
                this.playVO();
            } else {
                this.pauseVO();
            }
        }));

        this.observers.push(this.store.observe('bullet', (current, prev) => {

            if (current[0] !== this.get('i')) return;

            const { levels } = this.get();

            const current_level = levels[current[1]];
            const direction = helpers.isReverse(current, prev) ? 'reverse' : 'forward';

            this.set({ current, current_level, direction });
            this.play();

        }, {init: false}));

        this.observers.push(this.store.observe('muted', muted => {
            this.refs.audio.muted = muted;
        }, { defer: true }));

        this.observers.push(this.store.observe('index_active', current => {
            if (current) {
                this.pauseVO();
            } else if ( this.store.get('current_slide') == this.get('i') ) {
                this.play();
                this.playVO();
            }
        }));

        helpers.syncCues(this.refs.track, this.refs.display);

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    methods: {
        // play the visible video, which should always only be one
        play() {
            const video = this.refs.videos.querySelector('.current');
            if ( this.get('direction') == 'reverse' && this.get('current')[1] == 2 ) {
                video.currentTime = video.duration - 0.1;
                return;
            }

            if (video) {
                this.set({ show_label: false });
                video.play().catch(helpers.noop);
            }
        },

        playVO() {
            if ( this.get('direction') == 'reverse' ) return;
            const audio = this.refs.audio;
            audio && audio.play().catch(helpers.noop);
        },

        pauseVO() {
            const audio = this.refs.audio;
            audio && !audio.paused && audio.pause();
        },

        onEnd(e) {
            this.set({ show_label: true });
            this.resetInactive();
        },

        resetInactive() {
            const inactive = this.refs.videos.querySelectorAll(':not(.current)');

            for (var i = inactive.length - 1; i >= 0; i--) {
                inactive[i].currentTime = 0;
            }
        }
    },

    helpers: {
        video: helpers.video,
        media: helpers.media,

        isCurrent(level, current_level, current_direction, direction) {
            return level.name === current_level.name && current_direction === direction ?
                'current' : '';
        }
    }
}
</script>